module.exports = __webpack_public_path__ + "static/media/9.Power Sprayer Hose.5a0bf516.jpg";